<template>
    <!-- Start Agency Main Banner -->
    <div class="agency-main-banner">
        <div class="container-fluid">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="agency-banner-content">
                        <span class="sub-title">We are creative</span>
                        <h1>Digital Agency</h1>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        <a href="#" class="btn btn-secondary">Get Started</a>
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="agency-banner-image">
                        <img src="../../../assets/img/agency-image/banner-img.jpg" alt="image">
                    </div>
                </div>
            </div>
        </div>

        <div class="shape2 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>
        <div class="shape8 rotateme"><img src="../../../assets/img/shape2.svg" alt="shape"></div>

        <div class="shape3"><img src="../../../assets/img/shape3.svg" alt="shape"></div>
        <div class="shape4"><img src="../../../assets/img/shape4.svg" alt="shape"></div>
        
    </div>
    <!-- End Agency Main Banner -->
</template>

<script>
export default {
    name: 'Banner'
}
</script>